import { useEffect, useState } from "react";
import { REGISTRATION_OPENS_AT } from "../config/event";
import { getTimeLeft } from "../lib/registration";

const TICK_MS = 1000;

/** Live countdown to the registration opening. Stops ticking once registration is open. */
export const useRegistrationClock = (opensAt = REGISTRATION_OPENS_AT) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(Date.now(), opensAt));

  useEffect(() => {
    if (timeLeft.isOver) return undefined;
    const intervalId = setInterval(() => setTimeLeft(getTimeLeft(Date.now(), opensAt)), TICK_MS);
    return () => clearInterval(intervalId);
  }, [opensAt, timeLeft.isOver]);

  return { isOpen: timeLeft.isOver, timeLeft };
};
